import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const HolyGhosts2: Portfolio = {
    path: "holy-ghosts-2",
    name: "Holy Ghosts 2",
    pageStyle: PageStyle.Tan,
    pieces: [
        {image: "holy-ghosts-24.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 24", size: "19 \u00d7 20", pixelWidth: 386, pixelHeight: 360},
        {image: "holy-ghosts-25.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 25", size: "19 \u00d7 20", pixelWidth: 389, pixelHeight: 360},
        {image: "holy-ghosts-26.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 26", size: "19 \u00d7 20", pixelWidth: 392, pixelHeight: 360},
        {image: "holy-ghosts-27.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 27", size: "19 \u00d7 20", pixelWidth: 393, pixelHeight: 360},
        {image: "holy-ghosts-28.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 28", size: "19 \u00d7 20", pixelWidth: 338, pixelHeight: 360},
        {image: "holy-ghosts-29.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 29", size: "19 \u00d7 20", pixelWidth: 385, pixelHeight: 360},
        {image: "holy-ghosts-30.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 30", size: "19 \u00d7 20", pixelWidth: 383, pixelHeight: 360},
        {image: "holy-ghosts-31.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 31", size: "19 \u00d7 20", pixelWidth: 330, pixelHeight: 360},
        {image: "holy-ghosts-32.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 32", size: "19 \u00d7 20", pixelWidth: 328, pixelHeight: 360},
        {image: "holy-ghosts-33.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 33", size: "19 \u00d7 20", pixelWidth: 391, pixelHeight: 360},
        {image: "holy-ghosts-34.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 34", size: "19 \u00d7 20", pixelWidth: 392, pixelHeight: 360},
        {image: "holy-ghosts-35.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 35", size: "19 \u00d7 20", pixelWidth: 391, pixelHeight: 360},
        {image: "holy-ghosts-36.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 36", size: "19 \u00d7 20", pixelWidth: 388, pixelHeight: 360},
        {image: "holy-ghosts-37.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 37", size: "19 \u00d7 20", pixelWidth: 233, pixelHeight: 360},
        {image: "holy-ghosts-38.jpg", thumbAlt: "Holy Ghosts", title: "Holy Ghosts II 38", size: "19 \u00d7 20", pixelWidth: 237, pixelHeight: 360},
    ],
    piecesColumns: 9,
    statementTitle: "Holy Ghosts 2",
    statement: {
        leftColumn: [
            "September 2012",
            "The inspiration for this work comes from the most ancient artists, using natural dyes and tools, creating " +
            "beautiful images on 30,000 year old cave walls. The human drive to produce aesthetic renderings of our " +
            "stories is at the same time humbling and compelling. These prints are a silent prayer to the sacredness " +
            "of our natural world and to the ongoing tragedy of how much we have compromised its beauty and health. " +
            "It is, as well, a statement of gratitude for all the beauty and richness that is still with us.",
        ],
        rightColumn: [
            "The lines used in the prints have a fragile and genuine feel, meant to evoke the human touch and the " +
            "antiquity of the early marks. Salt resist is used to suggest the old rocks and walls and the diminishment " +
            "of endangered plants and animals. Many layers are used in the printing, just as layers have formed " +
            "over the years in the geological landscape.",
        ],
    },
};

export default HolyGhosts2;
